import React from "react";

import { FieldPath, FieldValues } from "react-hook-form";

import { LoadingInput } from "@/components/atoms";
import RadioButtonGroup, { RadioButtonGroupProps } from "@/components/atoms/Form/RadioButtonGroup/RadioButtonGroup";
import { useStaticQuery } from "@/shared/apis/referenceApi";

import { RefType, staticTables } from "../utils";

export type RefRadioButtonGroup<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<RadioButtonGroupProps<TFieldValues, TName>, "options"> & { table: RefType };

const RefRadioButtonGroup = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
    table,
    label,
    ...props
}: RefRadioButtonGroup<TFieldValues, TName>): React.ReactElement => {
    const staticTable = staticTables[table];
    const { options } = useStaticQuery(staticTable.path);
    if (options.length === 0) return <LoadingInput />;
    return <RadioButtonGroup options={options} label={label || label === "" ? label : staticTable.label} {...props} />;
};

export default RefRadioButtonGroup;
